import React from "react";
import PropTypes from "prop-types";
import SFChip from "../chip";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

const SFChipStyled = styled(SFChip, {
  shouldForwardProp: (prop) =>
    prop !== "bgColorName" &&
    prop !== "outlColorName" &&
    prop !== "active" &&
    prop !== "inDrawer",
})(({ theme, bgColorName, outlColorName, active, disabled, inDrawer }) => ({
  backgroundColor: active
    ? theme.palette[bgColorName].main
    : theme.palette.grey100.main,
  borderRadius: 30,
  outline: `1px solid ${
    active
      ? theme.palette[outlColorName || bgColorName].main
      : theme.palette.grey250.main
  }`,
  ...(!disabled && {
    "&:hover": {
      backgroundColor: theme.palette[bgColorName].main,
      "& .MuiChip-label": {
        color: theme.palette.white.main,
      },
    },
  }),
  cursor: "pointer",
  minWidth: inDrawer ? 100 : 175,
  width: "100%",
  height: 25,
  "& .MuiChip-label": {
    ...theme.typography.body2,
    color: active ? theme.palette.white.main : theme.palette.grey350.main,
    fontSize: 12,
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

const Pill = ({
  children,
  color,
  outlineColor,
  active,
  disabled,
  inDrawer = false,
}) => {
  return (
    <SFChipStyled
      bgColorName={color}
      outlColorName={outlineColor}
      active={active}
      disabled={disabled}
      inDrawer={inDrawer}
    >
      {children}
    </SFChipStyled>
  );
};

Pill.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  outlineColor: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  inDrawer: PropTypes.bool,
};

export default Pill;
